import { IEventImageListParams } from "../models/interface";
import eventImage from "../repositories/eventImage";

export default {
  getEventImages: async (params?: IEventImageListParams) => {
    const rs = await eventImage.getEventImages(params);
    if (!rs?.data) {
      return null;
    }
    return rs.data;
  },
  getEventImage: async (eventId: string) => {
    const rs = await eventImage.getEventImage(eventId);
    if (!rs?.data) {
      return null;
    }
    return rs.data;
  },
  getEventImageDetailsForHomePage: async (params?: { limit?: number }) => {
    const rs = await eventImage.getEventImageDetailsForHomePage(params);
    if (!rs?.data) {
      return null;
    }
    return rs.data;
  },
};
